/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Waehrung } from '../models';
/**
 * WaehrungService - axios parameter creator
 * @export
 */
export const WaehrungServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Währungen
         * @summary Währungen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWaehrungen: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/waehrungen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Währung
         * @summary Währungen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaehrungById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getWaehrungById', 'id', id)
            const localVarPath = `/api/waehrungen/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WaehrungService - functional programming interface
 * @export
 */
export const WaehrungServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WaehrungServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Währungen
         * @summary Währungen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllWaehrungen(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Waehrung>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllWaehrungen(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Währung
         * @summary Währungen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWaehrungById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Waehrung>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWaehrungById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * WaehrungService - factory interface
 * @export
 */
export const WaehrungServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WaehrungServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Währungen
         * @summary Währungen
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllWaehrungen(options?: any): AxiosPromise<Array<Waehrung>> {
            return localVarFp.getAllWaehrungen(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Währung
         * @summary Währungen
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWaehrungById(id: number, options?: any): AxiosPromise<Waehrung> {
            return localVarFp.getWaehrungById(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WaehrungService - interface
 * @export
 * @interface WaehrungService
 */
export interface WaehrungServiceInterface {
    /**
     * Liefert eine Liste von Währungen
     * @summary Währungen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaehrungServiceInterface
     */
    getAllWaehrungen(options?: any): AxiosPromise<Array<Waehrung>>;

    /**
     * Liefert eine Währung
     * @summary Währungen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaehrungServiceInterface
     */
    getWaehrungById(id: number, options?: any): AxiosPromise<Waehrung>;

}

/**
 * WaehrungService - object-oriented interface
 * @export
 * @class WaehrungService
 * @extends {BaseAPI}
 */
export class WaehrungService extends BaseAPI implements WaehrungServiceInterface {
    /**
     * Liefert eine Liste von Währungen
     * @summary Währungen
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaehrungService
     */
    public getAllWaehrungen(options?: any) {
        return WaehrungServiceFp(this.configuration).getAllWaehrungen(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Währung
     * @summary Währungen
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WaehrungService
     */
    public getWaehrungById(id: number, options?: any) {
        return WaehrungServiceFp(this.configuration).getWaehrungById(id, options).then((request) => request(this.axios, this.basePath));
    }
}
